/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svd_Runtimes_NoteInputs */

const en_svd_runtimes_note = /** @type {(inputs: Svd_Runtimes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all runtimes production-validated`)
};

const ar_svd_runtimes_note = /** @type {(inputs: Svd_Runtimes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع البنى معتمدة للإنتاج`)
};

const bn_svd_runtimes_note = /** @type {(inputs: Svd_Runtimes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব রানটাইম প্রোডাকশন-ভ্যালিডেটেড`)
};

const de_svd_runtimes_note = /** @type {(inputs: Svd_Runtimes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alle Laufzeiten produktionsvalidiert`)
};

const es_svd_runtimes_note = /** @type {(inputs: Svd_Runtimes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`todos los tiempos de ejecución validados en producción`)
};

const fr_svd_runtimes_note = /** @type {(inputs: Svd_Runtimes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tous les environnements d'exécution validés en production`)
};

const pt_svd_runtimes_note = /** @type {(inputs: Svd_Runtimes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`todos os tempos de execução validados para produção`)
};

const zh_svd_runtimes_note = /** @type {(inputs: Svd_Runtimes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有运行时均经过生产验证`)
};

const tr_svd_runtimes_note = /** @type {(inputs: Svd_Runtimes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tüm çalışma zamanları üretim açısından doğrulanmıştır`)
};

const ru_svd_runtimes_note = /** @type {(inputs: Svd_Runtimes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`все среды выполнения проверены на производстве`)
};

const pl_svd_runtimes_note = /** @type {(inputs: Svd_Runtimes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wszystkie środowiska wykonawcze zostały sprawdzone w środowisku produkcyjnym`)
};

/**
* | output |
* | --- |
* | "all runtimes production-validated" |
*
* @param {Svd_Runtimes_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svd_runtimes_note = /** @type {((inputs?: Svd_Runtimes_NoteInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svd_Runtimes_NoteInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svd_runtimes_note(inputs)
	if (locale === "bn") return bn_svd_runtimes_note(inputs)
	if (locale === "de") return de_svd_runtimes_note(inputs)
	if (locale === "es") return es_svd_runtimes_note(inputs)
	if (locale === "fr") return fr_svd_runtimes_note(inputs)
	if (locale === "pt") return pt_svd_runtimes_note(inputs)
	if (locale === "zh") return zh_svd_runtimes_note(inputs)
	if (locale === "tr") return tr_svd_runtimes_note(inputs)
	if (locale === "ru") return ru_svd_runtimes_note(inputs)
	if (locale === "pl") return pl_svd_runtimes_note(inputs)
	return en_svd_runtimes_note(inputs)
});